import React from "react";

const BenchmarkIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="8"
        width="2.5"
        height="5"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.2"
      ></rect>
      <rect
        x="5.5"
        y="5"
        width="2.5"
        height="8"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.2"
      ></rect>
      <rect
        x="10"
        y="2"
        width="2.5"
        height="11"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.2"
      ></rect>
    </svg>
  );
};

export default BenchmarkIcon;
